import React from "react";
import { useMutation } from "@apollo/client";

import { RemoveModal } from "components/modal/remove";
import { deleteTeamMember, deleteTeamMemberVariables, getTeamByOrgId_organization_team as User } from "types/gql-types";

import { DELETE_USER_MUTATION } from "./query";

type Props = {
  user: User;
};

const DELETE_TEMPLATE_CONFIRM = "Are you sure you want to delete ";
const DELETE_ERROR =
  "Unable to delete this user. Please try again or contact support@havenconnect.com.";

export const RemoveUser: React.FC<Props> = ({ user }: Props) => {
  const [removeUser] =
  useMutation<deleteTeamMember, deleteTeamMemberVariables>(DELETE_USER_MUTATION);

  const action = () => removeUser({
    variables: { id: user.id },
    refetchQueries: ["getTeamByOrgId"],
  });

  return (<RemoveModal
    action={action}
    buttonText="Delete"
    removalText={`${DELETE_TEMPLATE_CONFIRM}${user.fullName}?`}
    errorText={DELETE_ERROR}
  />);
};
